/** Origen de publicaciones automáticas de eventos (workflow n8n). */
export const COMUNIDAD_EVENTOS_N8N_SOURCE = 'n8n';

export function isComunidadEventoN8n(row) {
  const src = row?.metadata && typeof row.metadata === 'object' ? String(row.metadata.source ?? '').trim() : '';
  return src === COMUNIDAD_EVENTOS_N8N_SOURCE;
}

/** Dominio legible de fuente_url (p. ej. «elpais.com»). */
export function comunidadFuenteDominio(url) {
  const t = String(url ?? '').trim();
  if (!t) return '';
  try {
    const href = /^https?:\/\//i.test(t) ? t : `https://${t}`;
    const host = new URL(href).hostname.replace(/^www\./i, '');
    return host || '';
  } catch (_) {
    return '';
  }
}

export function comunidadAutorLabel(row, namesById = {}) {
  if (isComunidadEventoN8n(row)) {
    const dom = comunidadFuenteDominio(row?.fuente_url);
    if (dom) return dom;
    return 'n8n · automático';
  }
  const autor = namesById[row?.author_id];
  if (autor?.trim()) return `@${autor.trim()}`;
  if (row?.author_id) return `@${String(row.author_id).slice(0, 8)}`;
  return '—';
}
